import { getPublicConfigVariable } from '@lib/utils/getConfigVariable'
import { CookieValueTypes } from 'cookies-next'
import { z } from 'zod'

const ReservedListingSchema = z.object({
  saleId: z.number(),
  title: z.string(),
  thumbnailUrl: z.string().url()
})

export type ReservedListing = z.infer<typeof ReservedListingSchema>

export const CreateTransactionSessionParamsSchema = z.object({
  userId: z.number(),
  checkoutProvider: z.string(),
  shippingProvider: z.string(),
  shippingAddressId: z.number(),
  products: z.array(ReservedListingSchema),
  royaltyDonationAmount: z.number(),
  promotionCode: z.optional(z.string()),
  cancelRedirectUrl: z.string().url().optional(),
  successRedirectUrl: z.string().url().optional()
})

export type CreateTransactionSessionParams = z.infer<typeof CreateTransactionSessionParamsSchema>

type TransactionSession = {
  id: number
  checkoutProvider: string
  checkoutStatus: string
  checkoutCustomerId: string
  checkoutId: string
  checkoutPaymentId: string
  checkoutUrl: string
  couponProvider: string
  couponId: string
  UserId: number
  shippingProvider: string
  shippingAddressId: number
  royaltyDonationAmount: number
}

const apiPath = getPublicConfigVariable('LEGACY_API_URL')

export const fetchTransactionStatus = async ({
  transactionSessionId,
  country
}: {
  transactionSessionId: string
  country: string
}): Promise<{
  message: string
  data: {
    status: 'canceled' | 'pending' | 'completed'
    id: string
  }
}> => {
  return fetch(`${apiPath}/transaction/session/${transactionSessionId}/status`, {
    headers: {
      country
    }
  }).then((response) => response.json())
}

export const createHostedCheckoutUrl = async ({
  body,
  country,
  token
}: {
  body: CreateTransactionSessionParams
  country: string
  token: CookieValueTypes
}): Promise<TransactionSession> => {
  return fetch(`${apiPath}/transaction/session`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      country
    }
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code && responseJson.code !== 200) {
        throw new Error(responseJson.message || 'Failed to create transaction session')
      }
      return responseJson.data
    })
    .catch((error) => {
      console.error('There has been a problem with the fetch operation:', error)
      throw error
    })
}
